import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import dayjs from "dayjs"

import { formatDateDataGrid } from "src/utils/format-date"
import { DATE_FORMAT_SHOW } from "src/utils/constants"

import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterEmissaoRendaFixaConversibilidadeTable = (props) => {
    const datalakeService = new DatalakeService()

    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({
        count: 0,
        next: null,
        previous: null
    })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)

        datalakeService
            .loadPaginationEndpoint(props.endpoint)
            .then((response) => {
                const { results, count, next, previous } = response.body
                const list = results.map((obj) => ({ ...obj, id: obj.ID }))

                setPagination({ count, next, previous })
                setData(list)
            })
            .catch(props.callbackError)
            .finally(() => props.loading(false))
    }

    const updateRow = async (newRow) => {
        const {
            ID,
            RendaFixaCaracteristicasID,
            IDEmissao,
            CETIP,
            VersaoDocumento,
            DataReferencia,
            PrecoConversao,
            PremioConversao,
            Ticker,
            ConversaoFacultativa,
            ConversaoMandatoria,
            DataInicioConversao,
            DataFimConversao,
            LimiteConversao,
            TipoPrecoConversao,
            JanelaPregoes,
            PercentualPregoes
        } = newRow

        const body = {
            RendaFixaCaracteristicasID,
            IDEmissao,
            CETIP,
            VersaoDocumento,
            DataReferencia,
            PrecoConversao,
            PremioConversao,
            Ticker,
            ConversaoFacultativa,
            ConversaoMandatoria,
            DataInicioConversao,
            DataFimConversao,
            LimiteConversao,
            TipoPrecoConversao,
            JanelaPregoes,
            PercentualPregoes
        }

        props.loading(true)

        return datalakeService
            .updateTableEndpoint(props.endpoint, ID, body)
            .catch((err) => {
                props.loading(false)
                throw err
            })
            .finally(() => props.loading(false))
    }


    const onFilter = async (filterList, limit, offset) => {
        const query = filterList
            .map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`)
            .join('&')

        props.loading(true)

        datalakeService
            .loadPaginationEndpoint(props.endpoint, query, limit, offset)
            .then((response) => {
                const { results, count, next, previous } = response.body
                const list = results.map((obj) => ({ ...obj, id: obj.ID }))

                setPagination({ count, next, previous })
                setData(list)
            })
            .finally(() => props.loading(false))
    }

    const changePage = async (endpoint) => {
        props.loading(true)

        datalakeService
            .paginate(endpoint)
            .then((response) => {
                const { results, count, next, previous } = response.body
                const list = results.map((obj) => ({ ...obj, id: obj.ID }))

                setPagination({ count, next, previous })
                setData(list)
            })
            .finally(() => props.loading(false))
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            minWidth: 80,
            disableColumnMenu: true,
            disableFilter: true
        },
        {
            field: 'RendaFixaCaracteristicasID',
            headerName: 'RendaFixaCaracteristicasID',
            minWidth: 220,
            editable: true,
            typeComponent: 'number',
            disableColumnMenu: true
        },
        {
            field: 'IDEmissao',
            headerName: 'IDEmissao',
            minWidth: 200,
            editable: true,
            disableColumnMenu: true
        },
        {
            field: 'CETIP',
            headerName: 'CETIP',
            minWidth: 160,
            editable: true,
            disableColumnMenu: true
        },
        {
            field: 'VersaoDocumento',
            headerName: 'Versao Documento',
            typeComponent: 'number',
            minWidth: 160,
            editable: true,
            disableColumnMenu: true
        },
        {
            field: 'DataReferencia',
            headerName: 'Data Referencia',
            minWidth: 180,
            typeComponent: 'date',
            editable: true,
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'PrecoConversao',
            headerName: 'Preco Conversao',
            minWidth: 180,
            editable: true,
            typeComponent: 'number',
            disableColumnMenu: true
        },
        {
            field: 'PremioConversao',
            headerName: 'Premio Conversao',
            minWidth: 180,
            editable: true,
            typeComponent: 'number',
            disableColumnMenu: true
        },
        {
            field: 'DataInicioPreco',
            headerName: 'Data Ínicio Preco',
            minWidth: 220,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true
        },
        {
            field: 'Ticker',
            headerName: 'Ticker',
            minWidth: 120,
            editable: true,
            disableColumnMenu: true
        },
        {
            field: 'ConversaoFacultativa',
            headerName: 'Conversao Facultativa',
            minWidth: 200,
            editable: true,
            typeComponent: 'number',
            disableColumnMenu: true
        },
        {
            field: 'ConversaoMandatoria',
            headerName: 'Conversao Mandatoria',
            minWidth: 200,
            editable: true,
            typeComponent: 'number',
            disableColumnMenu: true
        },
        {
            field: 'DataInicioConversao',
            headerName: 'Data Ínicio Conversão',
            minWidth: 220,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true
        },
        {
            field: 'DataFimConversao',
            headerName: 'Data Fim Convers˜o',
            minWidth: 220,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true
        },
        {
            field: 'LimiteConversao',
            headerName: 'Limite Convers˜o',
            minWidth: 220,
            editable: true,
            typeComponent: 'number',
            disableColumnMenu: true
        },
        {
            field: 'TipoPrecoConversao',
            headerName: 'Tipo Preco Conversão',
            minWidth: 220,
            editable: true,
            disableColumnMenu: true
        },
        {
            field: 'JanelaPregoes',
            headerName: 'Janela Pregoes',
            minWidth: 180,
            editable: true,
            typeComponent: 'number',
            disableColumnMenu: true
        },
        {
            field: 'PercentualPregoes',
            headerName: 'Percentual Pregões',
            minWidth: 200,
            editable: true,
            typeComponent: 'number',
            disableColumnMenu: true
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            minWidth: 150,
            disableFilter: true,
            disableColumnMenu: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            minWidth: 150,
            disableFilter: true,
            disableColumnMenu: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <ParameterPaginationTable
            columns={columns}
            data={data}
            setData={setData}
            updateRow={updateRow}
            pagination={pagination}
            onChangePage={changePage}
            filterFunction={onFilter}
            customFilter
            useDeleteButton={false} 
        />
    )
}

ParameterEmissaoRendaFixaConversibilidadeTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterEmissaoRendaFixaConversibilidadeTable
